import React, { useEffect, useState, useMemo } from "react";
import { Grid } from "@material-ui/core";
import { Button, ButtonHLPure, DialogAcceptSignatureAutographReliable, DialogSystemGLPure } from "../../pures";
import DialogPdf from "../../pures/signature-request-detail/dialog-pdf";
import "./sign-request-reliable-signature.css";
import PdfReader from '../../pures/adobePfdReader/PdfReader'
import { useTranslation } from "react-i18next";

function SignRequestReliableSignatureView(props) {
  const {
    showSignModal,
    onToggleSignModal,
    setSignatureImgeData,
    setImgSignature,
    pdfFileBase64,
    onErrorTimeStamp
  } = props;
  const { t } = useTranslation()
  const { step, onHandleBack, onHandleNext } = props;
  const { next, back } = step;
  const [currentSystem, setCurrentSystem] = useState("");
  const [blobUrl, setBlobUrl] = useState("");
  const [blob, setBlob] = useState("");
  const [signRequestPDFURL, setSignRequestPDFURL] = useState('')

  const pdf = useMemo(() => <PdfReader className="pdfReader" url={blobUrl} awsURL src={blobUrl}  ></PdfReader>, [blobUrl])

  useEffect(() => {
    if (props.requestReliablePDF) {
      setBlobUrl(URL.createObjectURL(props.requestReliablePDF));
      setBlob(props.requestReliablePDF);
    }
  }, [props.requestReliablePDF]);

  useEffect(() => {
    setCurrentSystem(navigator.userAgent);
  }, []);

  let infodevice = currentSystem.toLowerCase();
  let isMobile = infodevice.includes("android");
  isMobile = isMobile || infodevice.includes("iphone");
  isMobile = isMobile || infodevice.includes("ipad");
  isMobile = isMobile || infodevice.includes("mobile");

  function isTouchScreendevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
  }

  if (isTouchScreendevice()) {
    isMobile = true;
  }

  return (
    <div className="card-description-reliable">
      <Grid
        item
        // xs={12}
        // lg={12}
        // md={12}
        // sm={12}
        // es={12}
        className="container-pdf-sign-request center-container-reliable-pdf"
      >
        {props.requestReliablePDF === "" ||
          props.requestReliablePDF === null ? null : (
          <div className="container-pdf">
            {isMobile ? (
              <div className="pdf-btn">
                <DialogPdf blobUrl={blob} />
              </div>
            ) : (
              // <PdfReader className="pdfReader" url={blobUrl} awsURL src={blobUrl} />
              pdf
            )}
          </div>
        )}
      </Grid>
      <div className="SignRequestReliableSignatureView-action-buttons">
        <ButtonHLPure
          nameBtn={back}
          onClickBtn={onHandleBack}
        />
        <ButtonHLPure
          nameBtn={next}
          primary
          onClickBtn={onToggleSignModal}
        />
      </div>
      {showSignModal && (
        <DialogAcceptSignatureAutographReliable
          setImgSignature={setImgSignature} // Update image file
          setSignatureImgeData={setSignatureImgeData} // Get the metadata of the image
          pdfFileBase64={pdfFileBase64}
          toggleDialogAccept={onToggleSignModal}
          onDeleteDataAccept={onToggleSignModal}
          onSubmit={() => { }}
          title={t("requestReliableSignature.dialog.fdaTitle")}
          onErrorTimeStamp={onErrorTimeStamp}
        />
      )}
      <DialogSystemGLPure
        {...props}
        toggleErrorRequesting={props.toggleErrorRequesting}
      />
    </div>
  );
}

export { SignRequestReliableSignatureView as default };
